//@flow
import _ from 'lodash';
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import DatePickerInput from '../../../components/inputs/DatePickerInput';
import FormInput from '../../../components/inputs/FormInput';
import FormSelectInput from '../../../components/inputs/FormSelectInput';
import InputViewEdit from '../../../components/inputs/InputViewEdit';
import SelectInput from '../../../components/inputs/SelectInput';
import { objectsEnuns } from '../../../_constants/objects.constants';
import { dateHelper } from '../../../_helpers/date.helper';
import { userService } from '../../../_services/user.service';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class EstoqueEntradaListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        {/* <FormGroup className="col-12 col-xl-3">
          <InputViewEdit
            label={'Tipo de entrada'}
            placeholder="Selecione o tipo de entrada"
            component={FormSelectInput}
            options={objectsEnuns.TIPO_ENTRADA_NOTA_FISCAL}
            labelKey={'label'}
            valueKey={'value'}
            returnFullObject={false}
            defaultValue={_.get(entity, 'type')}
            value={_.get(entity, 'type')}
            id="type"
            name="type"
            onChange={this.props.onChangeDate}
          />
        </FormGroup> */}
        <FormGroup className="col-12 col-md-2">
          <InputViewEdit
            component={DatePickerInput}
            label="Data Inicial"
            name="dataHoraLancamentoInicio"
            id="dataHoraLancamentoInicio"
            value={entity.dataHoraLancamentoInicio}
            onChange={this.props.onChangeDate}
            placeholder={'--/--/----'}
            defaultValue={
              _.get(entity, `dataHoraLancamentoInicio`)
                ? dateHelper.format(_.get(entity, `dataHoraLancamentoInicio`), {
                    mode: 'DATE-TIME',
                  })
                : '--'
            }
          />
        </FormGroup>
        <FormGroup className="col-12 col-md-2">
          <InputViewEdit
            component={DatePickerInput}
            label="Data Final"
            name="dataHoraLancamentoFim"
            id="dataHoraLancamentoFim"
            value={entity.dataHoraLancamentoFim}
            onChange={this.props.onChangeDate}
            placeholder={'--/--/----'}
            defaultValue={
              _.get(entity, `dataHoraLancamentoFim`)
                ? dateHelper.format(_.get(entity, `dataHoraLancamentoFim`), {
                    mode: 'DATE-TIME',
                  })
                : '--'
            }
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-2">
          <SelectInput
            options={objectsEnuns.TIPO_ENTRADA}
            type="text"
            name="tipoEntrada"
            label="Tipo de entrada"
            placeholder="Selecione o tipo de entrada"
            onChange={this.props.onChangeDate}
            id="tipoEntrada"
            returnFullObject={false}
            labelKey={'label'}
            valueKey={'value'}
            value={_.get(entity, 'tipoEntrada')}
            defaultValue={_.get(entity, 'tipoEntrada')}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <InputViewEdit
            component={SelectInput}
            label={'Nome ou Cpf / CNPJ do usuário'}
            id="responsavel"
            name="responsavel"
            placeholder="Nome ou Cpf / CNPJ do usuário"
            value={_.get(entity, 'responsavel')}
            defaultValue={
              _.get(entity, 'responsavel')
                ? _.get(entity, 'responsavel').cpfCnpjJoinName
                : '--'
            }
            onChange={this.props.onChangeDate}
            noSize={true}
            returnFullObject={true}
            valueKey={'id'}
            labelKey={'cpfCnpjJoinName'}
            multi={false}
            onFetchData={userService.findByCpfCnpjOrName}
            sortKey={'cpfCnpjJoinName'}
          />
        </FormGroup>

        <FormGroup className="col-12 col-xl-3">
          <SelectInput
            options={objectsEnuns.SITUACAO_PRODUTO}
            type="text"
            name="situacao"
            label="Situação"
            placeholder="Selecione a situação do produto"
            onChange={this.props.onChangeDate}
            id="situacao"
            returnFullObject={false}
            labelKey={'label'}
            valueKey={'value'}
            value={_.get(entity, 'situacao')}
            defaultValue={_.get(entity, 'situacao')}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
